export default __webpack_public_path__ + "static/media/logo2.54050611.svg";